import clientsReducer from "./clientsSlice";
import clientReducer from "./clientSlice";

const clients = {
  clients: clientsReducer,
  client: clientReducer,
};

export default clients;
